import { Link } from 'src/components/atoms/Link';
import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';

export const Description = styled.div`
  ${({ theme }) => {
    const isVaultVariant = theme.isVaultVariant;
    return isVaultVariant
      ? theme.newTypography.textStyleBodySmall
      : textStyleCss(theme.atlas.typography.semantic.caption);
  }}
  color: ${(props) => {
    const isVaultVariant = props.theme.isVaultVariant;
    return isVaultVariant
      ? props.theme.newPalette.neutral.N600
      : props.theme.atlas.semantic.color.type.muted;
  }};
`;

export const HeaderWrapper = styled.div`
  ${({ theme }) => {
    const isVaultVariant = theme.isVaultVariant;
    return isVaultVariant
      ? theme.newTypography.textStyleBodyLargeSemibold
      : textStyleCss(theme.atlas.typography.semantic.body);
  }}
  font-weight: 600;
  display: flex;
  flex: 4;
  justify-content: center;
`;

export const IconContainer = styled.div``;

export const Heading = styled.div`
  ${({ theme }) => {
    const isVaultVariant = theme.isVaultVariant;
    return isVaultVariant
      ? theme.newTypography.textStyleBodyLargeSemibold
      : textStyleCss(theme.atlas.typography.semantic.body);
  }}
  font-weight: 600;
  margin-top: 20px;
  text-align: center;
`;

export const ResultDescription = styled.div`
  ${({ theme }) => {
    const isVaultVariant = theme.isVaultVariant;
    return isVaultVariant
      ? theme.newTypography.textStyleBodySmall
      : textStyleCss(theme.atlas.typography.semantic.caption);
  }}
  color: ${(props) => {
    const isVaultVariant = props.theme.isVaultVariant;
    return isVaultVariant
      ? props.theme.newPalette.neutral.N600
      : props.theme.atlas.semantic.color.type.muted;
  }};
  margin-top: 20px;
  text-align: center;
`;

export const StyledLink = styled(Link)`
  ${({ theme }) => {
    const isVaultVariant = theme.isVaultVariant;
    return isVaultVariant
      ? theme.newTypography.textStyleBodySmall
      : textStyleCss(theme.atlas.typography.semantic.caption);
  }};
`;
